import angular from 'angular';
import template from './confirm-popup.html';
class ConfirmController {
    constructor() { }
    $onInit() {
        this.confirm = () => {
            if (this.onConfirm) {
                if (this.withPromise) {
                    this.confirmPromise = this.onConfirm().then(() => {
                        this.onClose();
                    });
                }
                else {
                    this.onConfirm();
                    this.onClose();
                }
            }
            else {
                this.onClose();
            }
        };
    }
}
const confirmPopup = {
    template,
    bindings: {
        header: '<',
        text: '<',
        confirmButtonText: '<',
        confirmButtonClass: '<',
        withPromise: '<',
        onConfirm: '&',
        onClose: '&',
    },
    controller: ConfirmController,
};
export default angular
    .module('doxy.common.components.confirmPopup', [])
    // waiting-room-edit-waiting-room-confirm
    .component('confirmPopup', confirmPopup).name;
